// NYC — conversor GLOBAL de medidas.
// No NYC o backend está em INCHES (nomes do WordPress). O default é inches,
// então normalmente não fazemos nada. Só convertemos a página inteira para CM
// quando o usuário escolhe 'cm' no toggle de unidades.

const excludedTags = new Set(['SCRIPT', 'STYLE']);

// Mapa inches -> cm com valores REDONDOS (padrão do catálogo NOVU).
// Confirmados pelo catálogo Paris: 12"=30, 16"=40, 18"=45, 39"=100.
const INCH_TO_CM = {
  '3': 8,
  '8': 20,
  '12': 30,
  '16': 40,
  '18': 45,
  '20': 50,
  '29': 75,
  '39': 100,
  '43': 110,
  '47': 120,
};

function inchToCmValue(numStr) {
  if (Object.prototype.hasOwnProperty.call(INCH_TO_CM, numStr)) {
    return INCH_TO_CM[numStr];
  }
  return Math.round(parseFloat(numStr) * 2.54);
}

function convertInchesToCmGlobally(root = document.body) {
  const walk = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
    acceptNode(node) {
      const parentTagName = node.parentElement?.tagName;
      return parentTagName && excludedTags.has(parentTagName)
        ? NodeFilter.FILTER_REJECT
        : NodeFilter.FILTER_ACCEPT;
    },
  });

  let currentNode;
  while ((currentNode = walk.nextNode())) {
    let val = currentNode.nodeValue ?? '';

    // 1) pés+polegadas (ex: 3'3" / 4’92”) -> cm
    val = val.replace(/(\d+)\s*['’]\s*(\d+)\s*["″]/g, (_, ft, inch) => {
      const cm = Math.round(parseInt(ft, 10) * 30.48 + parseInt(inch, 10) * 2.54);
      return `${cm}cm`;
    });
    // pés sozinhos (ex: 5')
    val = val.replace(/(\d+)\s*['’](?!\s*\d)/g, (_, ft) => {
      const cm = Math.round(parseInt(ft, 10) * 30.48);
      return `${cm}cm`;
    });
    // 2) polegadas simples (ex: 18" / 18″) -> cm (mapa)
    val = val.replace(/(\d+(?:\.\d+)?)\s*["″]/g, (_, num) => {
      return `${inchToCmValue(num)}cm`;
    });

    currentNode.nodeValue = val;
  }
}

window.convertInchesToCmGlobally = convertInchesToCmGlobally;

const selectedUnit = localStorage.getItem('novu_unit') || 'in'; // NYC default: inches

if (selectedUnit === 'cm') {
  convertInchesToCmGlobally();
}